function createOption(value: string) {
  return {
    label: value,
    value,
  };
}

/**
 * 工厂options
 */
export const factoryOptions = [
  {
    label: "E1",
    value: "1000",
  },
  {
    label: "E2",
    value: "2000",
  },
  {
    label: "E4",
    value: "4000",
  },
  {
    label: "E5",
    value: "3000",
  },
];
/**
 * 寻源类别options
 */
export const sourcingTypeOptions = ["生产物料", "非生产物料"].map((item) =>
  createOption(item),
);

/**
 * 生产物料对应的寻源子类别
 */
const productionMaterialOptions = ["API", "輔料", "包材"].map((item) =>
  createOption(item),
);

/**
 * 生产物料对应的寻源子类别
 */
const nonProductionMaterialOptions = [
  "新项目",
  "工程建设",
  "设备/设施/仪器",
  "IT物资",
].map((item) => createOption(item));

/**
 * 根据寻源类别获取对应的寻源子类别options
 * @param sourcingType
 * @returns
 */
export function getSubSourcingTypeOptions(sourcingType: string) {
  if (sourcingType === "生产物料") return productionMaterialOptions;

  return nonProductionMaterialOptions;
}
